import cn from 'classnames';
import React, { useContext } from 'react';

import { ToothChartSize } from '../../config/types';
import { ToothChartContext } from '../ToothChartRoot/ToothChartRoot';

import styles from './ToothChartGrid.module.scss';

type ToothChartGridProps = {
  children: React.ReactNode;
  showLowerJaw?: boolean;
  showUpperJaw?: boolean;
  isPreview?: boolean;
};

const sizeStyles: Record<ToothChartSize, string> = {
  default: styles.sizeDefault,
  small: styles.sizeSmall,
  mobile: styles.sizeMobile,
};

export const ToothChartGrid = (props: ToothChartGridProps) => {
  const {
    children,
    showUpperJaw = true,
    showLowerJaw = true,
    isPreview = false,
  } = props;

  const size = useContext(ToothChartContext);

  return (
    <div
      data-component="tooth-chart-grid"
      className={cn(
        styles.container,
        sizeStyles[size],
        !showUpperJaw && styles.hideUpperJaw,
        !showLowerJaw && styles.hideLowerJaw,
        isPreview && styles.preview,
      )}
    >
      {children}
    </div>
  );
};
